import { render } from "./SimulationWorksForm.vue?vue&type=template&id=e2240490&scoped=true&ts=true"
import script from "./SimulationWorksForm.vue?vue&type=script&lang=ts"
export * from "./SimulationWorksForm.vue?vue&type=script&lang=ts"

import "./SimulationWorksForm.vue?vue&type=style&index=0&id=e2240490&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2240490"]])

export default __exports__